module.exports = __webpack_public_path__ + "static/media/18_l_stena_0_0.a9dda0a1.png";